export default __webpack_public_path__ + "static/2-68e220cee695a4b2a76305cb0c478b21.png";